// Textos y colores de las alertas, compartidos por la campana y la vista de alertas

export const SEVERITY = {
    CRITICAL: { label: 'Crítica', className: 'bg-red-100 text-red-700', dot: 'bg-red-600' },
    HIGH: { label: 'Alta', className: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
    MEDIUM: { label: 'Media', className: 'bg-yellow-100 text-yellow-700', dot: 'bg-yellow-500' },
    LOW: { label: 'Baja', className: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' },
};

export const ALERT_TYPE = {
    THRESHOLD: 'Umbral',
    FROST: 'Helada',
    VPD_HIGH: 'DPV alto',
    FUNGAL_RISK: 'Riesgo de hongos',
    HEAT_STRESS: 'Estrés térmico',
};

export const ALERT_STATUS = {
    OPEN: { label: 'Activa', className: 'bg-red-100 text-red-700' },
    RESOLVED: { label: 'Resuelta', className: 'bg-green-100 text-green-700' },
};

export const NOTIFICATION_STATUS = {
    SENT: { label: 'Enviado', className: 'text-green-700' },
    PENDING: { label: 'Pendiente', className: 'text-gray-600' },
    FAILED: { label: 'Falló', className: 'text-red-700' },
    SKIPPED: { label: 'Omitido', className: 'text-gray-500' },
};

export const CHANNEL = {
    EMAIL: 'Correo',
    WHATSAPP: 'WhatsApp',
};

// Alertas que evalúa el servidor automáticamente (AlertScheduler). Si se activa o
// se quita un detector en el backend, actualizar esta lista.
export const MONITORED_ALERTS = [
    {
        icon: 'ac_unit',
        name: 'Helada',
        schedule: 'Cada 30 minutos, de 6 p. m. a 8 a. m.',
        condition: 'Temperaturas bajas en el aire y el suelo. Distingue helada temprana, blanca y negra.',
    },
    {
        icon: 'water_drop',
        name: 'DPV alto (estrés hídrico)',
        schedule: 'Cada 30 minutos, de 8 a. m. a 6 p. m.',
        condition: 'Déficit de presión de vapor elevado de forma sostenida.',
    },
    {
        icon: 'coronavirus',
        name: 'Riesgo de hongos',
        schedule: 'Cada 30 minutos',
        condition: 'Periodos prolongados de humedad alta con temperaturas favorables para hongos.',
    },
];

export const isAdminUser = (user) => !!(user && user.authorities && user.authorities.includes('ROLE_ADMIN'));

export const canSeeAlerts = (user) => !!(user && user.authorities && user.authorities.includes('GET_ALERTS'));
